/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { StyleSheet, TouchableHighlight, View } from 'react-native';
import DyteClient from '@dytesdk/web-core';
import { SvgXml } from 'react-native-svg';
import { defaultIconPack, IconPack } from '../lib/icons';
import { DyteI18n, useLanguage } from '../lib/lang';
import DyteText from './DyteText';
import { useDyteSelector } from '@dytesdk/react-native-core';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  meeting,
  iconPack = defaultIconPack,
  size = 'sm',
  variant = 'button',
  t,
}: {
  meeting: DyteClient;
  iconPack?: IconPack;
  size?: 'lg' | 'md' | 'sm' | 'xl';
  variant?: 'button' | 'horizontal';
  t?: DyteI18n;
}) {
  const defaultLang = useLanguage();
  t = t ?? defaultLang;
  iconPack = iconPack ?? defaultIconPack;
  const { storeStates, setStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  const stageRef = useDyteSelector((m) => m.stage);
  const liveStreamStageStatus = stageRef.status;
  const toggleStage = () => {
    const self = meeting.self;
    if (self == null) {
      return;
    }
    if (liveStreamStageStatus === 'REQUESTED_TO_JOIN_STAGE') {
      meeting.stage.cancelRequestAccess();
      return;
    }
    setStates({ ...storeStates, activeStageConfirmation: true });
  };
  useEffect(() => {
    const updateCanProduceSS = () => {
      const { self, meta, stage } = meeting;
      let _canProduceSS = self.permissions.canProduceScreenshare === 'ALLOWED';
      const isLiveStream = meta.viewType === 'LIVESTREAM';
      if (!_canProduceSS && isLiveStream) {
        const canRequestVideo =
          self.permissions.canProduceScreenshare === 'CAN_REQUEST';
        // If the has approved request to present
        if (
          canRequestVideo &&
          (stage.status === 'ON_STAGE' ||
            stage.status === 'ACCEPTED_TO_JOIN_STAGE')
        ) {
          _canProduceSS = true;
        }
      }
    };

    updateCanProduceSS();
    meeting.stage.addListener('stageRequestApproved', updateCanProduceSS);
    meeting.stage.addListener('stageRequestRejected', updateCanProduceSS);
    meeting.stage.addListener('stageStatusUpdate', updateCanProduceSS);

    return () => {
      meeting.stage.removeListener('stageRequestApproved', updateCanProduceSS);
      meeting.stage.removeListener('stageRequestRejected', updateCanProduceSS);
      meeting.stage.removeListener('stageStatusUpdate', updateCanProduceSS);
    };
  }, [meeting]);

  const styles = StyleSheet.create({
    button: {
      justifyContent: 'center',
      alignItems: 'center',
      padding: 8,
    },
  });
  if (meeting.meta.viewType !== 'LIVESTREAM') return null;
  return (
    <View>
      <TouchableHighlight
        underlayColor={colors.background[800]}
        onPress={toggleStage}
        style={styles.button}
      >
        <View>
          {liveStreamStageStatus === 'OFF_STAGE' ? (
            <SvgXml
              xml={iconPack.join_stage.replace('currentColor', colors.text)}
              width={25}
              height={25}
            />
          ) : (
            <SvgXml
              xml={iconPack.leave_stage.replace('currentColor', colors.danger)}
              width={25}
              height={25}
            />
          )}
          {/* eslint-disable-next-line react-native/no-inline-styles*/}
          <DyteText style={{ fontSize: 11, marginTop: 0 }}>
            {liveStreamStageStatus === 'ON_STAGE' && 'Leave'}
            {liveStreamStageStatus === 'OFF_STAGE' && 'Join'}
            {liveStreamStageStatus === 'REQUESTED_TO_JOIN_STAGE' && 'Requested'}
          </DyteText>
        </View>
      </TouchableHighlight>
    </View>
  );
}
